import { render, staticRenderFns } from "./medicaments.vue?vue&type=template&id=362b5b69&scoped=true"
import script from "./medicaments.vue?vue&type=script&lang=js"
export * from "./medicaments.vue?vue&type=script&lang=js"
import style0 from "./medicaments.vue?vue&type=style&index=0&id=362b5b69&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362b5b69",
  null
  
)

export default component.exports